/* Indian festivals + aviation congestion peaks for 2026-2027.
   Hand-curated (Feb 2026). Severity is editorial — "high" means expect
   major airport queues and higher fares, "medium" means noticeably busier.
   `off_peak` is the suggested quieter window around the festival. */

export const FESTIVALS = [
  {
    id: "republic-day-2026",
    name: "Republic Day",
    date: "2026-01-26",
    peak_window: ["2026-01-24", "2026-01-27"],
    severity: "medium",
    airports: ["DEL", "BLR", "AMD"],
    note: "Delhi has a security tier-up and VIP movements around India Gate — allow 30 extra minutes landside.",
    off_peak: "Fly Jan 20-23 or after Jan 28.",
    image: "https://images.unsplash.com/photo-1532375810709-75b1da00537c?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "holi-2026",
    name: "Holi",
    date: "2026-03-04",
    peak_window: ["2026-03-01", "2026-03-07"],
    severity: "high",
    airports: ["DEL", "JAI", "LKO", "BOM", "AMD", "VNS"],
    note: "North India corridor sees a 25-30% surge — Delhi/Jaipur/Lucknow/Varanasi fares spike 60%. Diaspora return traffic ex-DXB/LHR peaks the week before.",
    off_peak: "Fly Mar 8-15 for cheapest return fares.",
    image: "https://images.unsplash.com/photo-1552642084-20cd3f2b0ed9?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "eid-ul-fitr-2026",
    name: "Eid ul-Fitr",
    date: "2026-03-21",
    peak_window: ["2026-03-19", "2026-03-23"],
    severity: "medium",
    airports: ["LKO", "HYD", "DEL", "BOM", "CCU"],
    note: "Delhi-Lucknow-Hyderabad corridors see diaspora return and domestic travel to home towns.",
    off_peak: "Fly Mar 24-30 for lower fares.",
    image: "https://images.unsplash.com/photo-1555689502-c4b22d76c56f?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "summer-break-2026",
    name: "Summer School Break",
    date: "2026-05-15",
    peak_window: ["2026-05-10", "2026-06-30"],
    severity: "high",
    airports: ["DEL", "BOM", "GOI", "GOX", "SXR", "IXL", "BLR", "COK"],
    note: "Six weeks of family travel — Goa, Kashmir, Leh and Kerala are the hot destinations. International DOH/DXB/SIN charters at full capacity.",
    off_peak: "Weekday mid-day departures are 20-30% cheaper than weekend evenings.",
    image: "https://images.unsplash.com/photo-1515410335-a4c4e3f1c2a9?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "monsoon-dip-2026",
    name: "Monsoon travel dip",
    date: "2026-07-15",
    peak_window: ["2026-07-01", "2026-08-31"],
    severity: "low",
    airports: ["BOM", "GOI", "COK", "TRV", "MAA"],
    note: "West + South coast flights see weather-related delays — BOM/COK/MAA fog or rain. Fares are the lowest of the year. Carry documents in waterproof pouches.",
    off_peak: "This IS the off-peak — great for backpackers and budget-conscious travellers.",
    image: "https://images.unsplash.com/photo-1414609245224-afa02bfb3fda?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "ganesh-chaturthi-2026",
    name: "Ganesh Chaturthi",
    date: "2026-09-14",
    peak_window: ["2026-09-12", "2026-09-16"],
    severity: "medium",
    airports: ["BOM", "PNQ", "HYD", "BLR"],
    note: "Mumbai-Pune corridor peaks — airlines add 10-15 extra flights. BOM T2 is particularly busy.",
    off_peak: "Fly Sep 17-24 for 30% cheaper fares.",
    image: "https://images.unsplash.com/photo-1601821765780-754fa98637c1?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "durga-puja-2026",
    name: "Durga Puja",
    date: "2026-10-16",
    peak_window: ["2026-10-14", "2026-10-20"],
    severity: "high",
    airports: ["CCU", "BBI", "GAU", "IXB"],
    note: "Kolkata and the entire east gets a 40%+ fare surge. CCU T2 operates at near-full capacity for a week.",
    off_peak: "Fly Oct 21-27 or before Oct 10.",
    image: "https://images.unsplash.com/photo-1558431382-27e303142255?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "diwali-2026",
    name: "Diwali",
    date: "2026-11-08",
    peak_window: ["2026-11-04", "2026-11-12"],
    severity: "high",
    airports: ["DEL", "BOM", "BLR", "HYD", "MAA", "AMD", "LKO", "JAI", "CCU"],
    note: "India's biggest aviation peak — all airports run at capacity. Fares 70-120% higher than normal. North India fog begins mid-Nov — book early morning departures.",
    off_peak: "Fly Nov 13-20 for the sharpest fare drops after Diwali.",
    image: "https://images.unsplash.com/photo-1511455329474-ea2fb21e5e4a?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "winter-fog-2026",
    name: "North India winter fog",
    date: "2026-12-15",
    peak_window: ["2026-12-15", "2027-01-31"],
    severity: "high",
    airports: ["DEL", "LKO", "VNS", "IXC", "ATQ"],
    note: "CAT-III capable crew/aircraft required. Non-CAT-III flights face delays or diversions. Book early-morning (04:00-07:00) or afternoon slots — avoid 23:00-03:00.",
    off_peak: "Avoid Dec 20-Jan 10 if possible. Fly from BOM/HYD/BLR instead when they offer non-stop options.",
    image: "https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "christmas-2026",
    name: "Christmas & New Year",
    date: "2026-12-25",
    peak_window: ["2026-12-20", "2027-01-05"],
    severity: "high",
    airports: ["GOI", "GOX", "COK", "TRV", "BOM", "DEL", "BLR"],
    note: "Goa and Kerala are the premier beach destinations. Diaspora return at peak — ex-DXB/LHR/SYD/EWR all see fare surges. Combine with winter fog on North India legs.",
    off_peak: "Fly Jan 7-20 for ~50% cheaper Goa/Kerala fares.",
    image: "https://images.unsplash.com/photo-1549557381-31a2976c7f4e?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "pongal-makar-sankranti-2027",
    name: "Pongal / Makar Sankranti",
    date: "2027-01-14",
    peak_window: ["2027-01-12", "2027-01-16"],
    severity: "medium",
    airports: ["MAA", "TRV", "COK", "BLR", "AMD"],
    note: "Tamil Nadu + Kerala + Gujarat see domestic surge for family travel.",
    off_peak: "Fly Jan 17-25.",
    image: "https://images.unsplash.com/photo-1582632431373-3eb4a7f7f0c7?auto=format&fit=crop&w=1600&q=80",
  },
];

/* Return the next upcoming festival (within `windowDays`) relative to `now`.
   null if nothing is coming up. */
export function nextUpcoming(now = new Date(), windowDays = 14) {
  const target = new Date(now.getTime() + windowDays * 86400000);
  let next = null;
  for (const f of FESTIVALS) {
    const [peakStart, peakEnd] = f.peak_window.map((d) => new Date(d));
    // currently inside the peak OR peak starts within the window
    if (peakEnd >= now && peakStart <= target) {
      if (!next || peakStart < new Date(next.peak_window[0])) next = f;
    }
  }
  return next;
}

export function festivalsForAirport(iata) {
  return FESTIVALS.filter((f) => f.airports.includes(iata));
}

export const SEVERITY_STYLES = {
  high: { bg: "bg-red-100", text: "text-red-800", border: "border-red-200", pill: "bg-red-600" },
  medium: { bg: "bg-amber-100", text: "text-amber-800", border: "border-amber-200", pill: "bg-amber-500" },
  low: { bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-200", pill: "bg-emerald-600" },
};
